(function () {
	'use strict';

	// Селекторы ссылок, ведущих на товар (которые нужно подменять)
	var PRODUCT_LINK_SELECTORS = [
		'a.link--product_link',          // оверлей внутри слайда
		'a.product_card_product-link',   // нижний оверлей карточки
		'.card__title a'                 // ссылка с заголовка
	].join(', ');

	// Получить URL активного слайда внутри карточки
	function getActiveSlideUrl(card) {
		var slider = card.querySelector('.product-card-js.swiper-container');
		if (!slider) {
			// слайдера нет (режим не slider) — берём data-variant-url первого слайда, если есть
			var anySlide = card.querySelector('[data-variant-url]');
			return anySlide ? anySlide.getAttribute('data-variant-url') : null;
		}

		// Swiper помечает активный слайд классом swiper-slide-active
		var active = slider.querySelector('.swiper-slide-active[data-variant-url]');

		// fallback на случай loop-дублей / отсутствия активного
		if (!active) {
			active = slider.querySelector('.swiper-slide[data-variant-url]');
		}

		return active ? active.getAttribute('data-variant-url') : null;
	}

	function handleCardClick(e) {
		var link = e.target.closest('a');
		if (!link) return;

		// не трогаем свотчи, quick view, коллекции, vendor
		if (link.closest('.js-color-swatches')) return;
		if (link.closest('quick-add-modal')) return;
		if (link.matches('.card__collection-title, .vendor-link')) return;

		// проверяем, что это именно «ссылка на товар»
		if (!link.matches(PRODUCT_LINK_SELECTORS)) return;

		var card = link.closest('.product-card');
		if (!card) return;

		var url = getActiveSlideUrl(card);
		if (url) {
			link.setAttribute('href', url);
		}
	}

	// capture-фаза: подменяем href ДО перехода
	document.addEventListener('click', handleCardClick, true);

	// Дополнительно: для средней кнопки мыши / Ctrl+Click (открытие в новой вкладке)
	document.addEventListener('auxclick', handleCardClick, true);
	document.addEventListener('mousedown', handleCardClick, true);
})();